<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17Z1YLI/tc-custom/9781635335033.jpg?1718282658316" alt="This image is the cover for the book Per una causa antica, Una buona causa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Per una causa antica, Una buona causa
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Una storia della serie Una buona causa</i></b></p><p>Il padre di Will Martin è un razzista; odia i nativi americani e vuole tenerli lontani dalla sua proprietà, anche se parte della terra del suo ranch è sacra per i Sioux. Quando la tribù chiede di potervi celebrare i propri riti, l’uomo rifiuta, ma Will non è d’accordo con lui. Da quando ha visto Takoda Red Bird durante una cerimonia religiosa Sioux, ne è rimasto affascinato, perciò decide di concedere alla tribù l’accesso alla terra.</p><p>Takoda è abituato ad andare contro la volontà del proprietario testardo: spesso si intrufola in quel luogo sacro per andare a pregare e sa che Will lo ha visto. Quando, per puro spregio, l’allevatore mette all’asta la terra, Takoda sa che è venuto il momento di agire e unisce le forze con Will per impedirne la vendita.</p><p>Lottare per questa causa ha più conseguenze di quante Will se ne aspettasse. All’inizio vuole soltanto aiutare la tribù a preservare la propria identità, ma alla fine trova la sua.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Grey, Ernesto Pavan
      </h2>
      
      <p class="authorDescription body article">Andrew Grey is the author of more than one hundred works of Contemporary Gay Romantic fiction. After twenty-seven years in corporate America, he has now settled down in Central Pennsylvania with his husband of more than twenty-five years, Dominic, and his laptop. An interesting m&eacute;nage. Andrew grew up in western Michigan with a father who loved to tell stories and a mother who loved to read them. Since then he has lived throughout the country and traveled throughout the world. He is a recipient of the RWA Centennial Award, has a master&rsquo;s degree from the University of Wisconsin&ndash;Milwaukee, and now writes full-time. Andrew&rsquo;s hobbies include collecting antiques, gardening, and leaving his dirty dishes anywhere but in the sink (particularly when writing). He considers himself blessed with an accepting family, fantastic friends, and the world&rsquo;s most supportive and loving partner. Andrew currently lives in beautiful, historic Carlisle, Pennsylvania.<BR />Email: andrewgrey@comcast.net<BR />Website: www.andrewgreybooks.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?292e315e